import React, { useState } from 'react';
import { useApp } from './context';
import { useRemote } from './api';
import { PageTitle, Empty } from './ui';
import { BusinessReview } from './approvals/BusinessReview';
import { ApprovalFilters, BusinessList, filterBusinesses } from './approvals/BusinessList';

const ApprovalWorkspace = () => {
  const remote = useRemote('/admin/businesses');
  const [filter, setFilter] = useState('pending');
  const [selected, setSelected] = useState(null);
  const businesses = remote.data || [];
  const reviewed = () => { setSelected(null); remote.reload(); };
  return <>
    <PageTitle eyebrow="A BUSINESS NETWORK BUILT ON TRUST" title="Business approvals.">
      Review company details before enabling trading access.
    </PageTitle>
    <div className="notice" data-testid="business-verification-policy">Manual review only. A correctly formatted GSTIN does not confirm government registration or certification.</div>
    <ApprovalFilters businesses={businesses} filter={filter} setFilter={setFilter} />
    <BusinessList remote={remote} rows={filterBusinesses(businesses, filter)} filter={filter} onReview={setSelected} />
    {selected && <BusinessReview key={selected.id} business={selected} onClose={() => setSelected(null)} onReviewed={reviewed} />}
  </>;
};

export default function BusinessApprovals() {
  const { user } = useApp();
  if (user.role !== 'admin') return <Empty title="Administrator access required"
    text="Business reviews are restricted to platform administrators." />;
  return <ApprovalWorkspace />;
}